import React from "react";
import { Outlet } from "react-router-dom";
import LogoLight from "../../assets/logo/logo-image.svg";

const AuthLayout = () => (
  <div className="auth">
    <div className="auth__panel">
      <img src={LogoLight} alt="Roots Funding" className="auth__brand" />
      <Outlet />
    </div>
  </div>
);

export default AuthLayout;
